import { Component, OnInit, Directive } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as firebase from 'firebase/app';
import 'firebase/storage';
import { ActivatedRoute, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';
import { AngularFireAuth } from 'angularfire2/auth';
import { AuthService } from '../../../services/auth/auth.service';
import { WindowService } from '../../../services/window/window.service';
import { FormsModule, FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
//import { FormControl } from '@angular/forms/src/model';
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection, docChanges } from 'angularfire2/firestore';
import { Observable, Subject } from 'rxjs/Rx';
import { User } from '../../datamodel/user';
import { UploadService } from '../../../uploads/shared/upload.service';
import { Upload } from '../../../uploads/shared/upload';
import { ToggleService } from '../../../services/toggle/toggle.service';
import { StateService } from '../../../services/state/state.service';
import { Institution } from '../../../modules/datamodel/institution';
import { Provider } from '../../../modules/datamodel/provider';
import { Department } from '../../../modules/datamodel/department';
import * as _ from 'underscore';
import { MatDatepicker } from '@angular/material';
import { Ng4LoadingSpinnerModule, Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
interface Shift {
	type: any;
}
interface ProviderShift {
	type: any;
}
interface scheduleShifts {
	type: any;
}
const httpOptions = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json',
		'Authorization': 'key=AIzaSyBDB_jgKH-eDllQnGWTQJiRmQ2vSS0hKag'
	})
};
@Component({
	moduleId: module.id,
	selector: 'app-edit-schedule',
	templateUrl: './edit-schedule.component.html',
	styleUrls: ['./edit-schedule.component.scss'],
	providers: [WindowService]
})
export class EditScheduleComponent implements OnInit {
	public editShiftForm: FormGroup;
	tab = 1;
	setTab(newTab) {
		this.tab = newTab;
	};
	isSet = function (tabNum) {
		return this.tab === tabNum;
	};
	
	public tagsList = ['Car', 'Bus', 'Train'];
	public autocompleteTags = [];
	public autocompleteItems = [
		'Banana',
		'Orange',
		'Apple',
		'Pear',
		'Grape',
		'Potato',
		'Peach'
	];
	

	public weekList:Array<any>;
	public selectedDoctors = [];
	public selRow = 0;
	public selCol = 0;
	
	public listDepartments = [];
	public listDoctors = [];
	private departmentRef: AngularFirestoreCollection<Department>;
	obsDepartments: Observable<Department[]>;
	public selectedInstitution: object;

	public userProfile: object;
	private userRef: AngularFirestoreCollection<User>;
	obsUser: Observable<any>;

	private instituteRef: AngularFirestoreCollection<Institution>;
	obsInstitute: Observable<any>;
	private doctorsRef: AngularFirestoreCollection<Provider>;
	obsDoctors: Observable<any>;

	activeId: string;
	public objSchedule: any;
	private scheduleRef: AngularFirestoreCollection<any>;
	obsSchedule: Observable<any>;

	private shiftsRef: AngularFirestoreCollection<any>;
	obsShifts: Observable<any>;

	private providerScheduleRef: AngularFirestoreCollection<any>;
	obsProviderSchedule: Observable<any>;
	private shiftRef: AngularFirestoreCollection<any>;
	obsShift: Observable<any>;

	constructor(private afs: AngularFirestore, public afAuth: AngularFireAuth, public auth: AuthService, private win: WindowService, private fb: FormBuilder, public toggle: ToggleService, private state: StateService, private router: Router, public route: ActivatedRoute, public http: HttpClient, private spinnerService: Ng4LoadingSpinnerService) {
		this.activeId == '';
	}

	dateFormat(dt){
		dt = new Date(dt);
		let dfm = [
			dt.getFullYear(),
			('0' + (dt.getMonth() + 1)).slice(-2),
			('0' + dt.getDate()).slice(-2)
		].join('-');
		return dfm;
	}

	getUserProfile() {
		let objUser = firebase.auth().currentUser;
		this.userRef = this.afs.collection('users', ref => ref.where('email', '==', objUser.email));
		this.obsUser = this.userRef.snapshotChanges().map(changes => {
			return changes.map(a => {
				const data = a.payload.doc.data() as User;
				const id = a.payload.doc.id;
				this.userProfile = { id: id, data: data };
				return { "id": id, "data": data };
			});
		});
		this.obsUser.subscribe(docs => {
			//console.log(docs[0].data.adminFor[0].name);
			this.getInstitute(docs[0].data.adminFor[0].name);
			this.getDoctorsList(docs[0].data.adminFor[0].id);
		});

	}

	getInstitute(hname) {
		this.instituteRef = this.afs.collection('institutions', ref => ref.where('name', '==', hname));
		this.obsInstitute = this.instituteRef.snapshotChanges().map(changes => {
			return changes.map(a => {
				const data = a.payload.doc.data() as Institution;
				const id = a.payload.doc.id;
				this.selectedInstitution = { id: id, data: data };
				return { "id": id, "data": data };
			});
		});
		this.obsInstitute.subscribe(docs => {
			//this.getDoctorsList(docs[0].data.name);
		})
	}

	getDepartmentList(){
		//create list of all the departments
		this.departmentRef = this.afs.collection('departments', ref => ref.orderBy('name'));
		this.obsDepartments = this.departmentRef.snapshotChanges().map(changes => {
			return changes.map(a => {
				const data = a.payload.doc.data() as Department;
				const id = a.payload.doc.id;
				this.listDepartments.push({ id: id, name: data.name });
				return { id, ...data };
			});
		});
		this.obsDepartments.subscribe(docs => {
			
		});
	}

	getDoctorsList(hid){
		this.doctorsRef = this.afs.collection('providers', ref => ref.where('credentialedAt.'+hid+'.id', '==', hid));
		this.obsDoctors = this.doctorsRef.snapshotChanges().map(changes => {
			return changes.map(a => {
				const data = a.payload.doc.data() as User;
				const id = a.payload.doc.id;
				//this.listDoctors.push({ id: id, data: data });
				return { id, ...data };
			});
		});
		this.obsDoctors.subscribe(docs => {
			console.log(docs);
			this.listDoctors = docs;
		});
	}

	initShift() {
		// initialize our address
		return this.fb.group({
			doc_type: new FormControl('', Validators.required),
			department: new FormControl(''),
			shift_type: new FormControl('', Validators.required),
			total_docs: new FormControl('', Validators.required)
		});
	}

	getScheduleDetails(pid) {
		const document: AngularFirestoreDocument<any> = this.afs.doc('schedules/' + pid);
		const document$: Observable<any> = document.valueChanges();
		document$.subscribe(data => {
			console.log(data);
			this.objSchedule = data;
			//set shift details object
			// let objScheduleShifts = [];
			// if (data.shifts.length > 0) {
			// 	for(let i in data.shifts){
			// 		objScheduleShifts[i] = {};
			// 		objScheduleShifts[i].doc_type = data.shifts[i].doc_type;
			// 		objScheduleShifts[i].department = data.shifts[i].department;
			// 		objScheduleShifts[i].shift_type = data.shifts[i].shift_type;
			// 		objScheduleShifts[i].total_docs = data.shifts[i].total_docs;
			// 		objScheduleShifts[i].providers = data.shifts[i].providers;
			// 	}
			// }
			this.editShiftForm.patchValue({
				name: data.name,
				tags: data.tags
				// start_date: data.start_date,
				// end_date: data.end_date,
				// shifts: data.shifts
			});
		});
	}


	goSchedulesList(){
		this.router.navigate(['/schedules']);
	}

	goBack(){
		this.tab = 1;
	}

	isFieldValid(field) {
		return !this.editShiftForm.get(field).valid && (this.editShiftForm.get(field).dirty || this.editShiftForm.get(field).touched);
	}

	isShiftFieldValid(field) {
		return !field.valid && (field.dirty || field.touched);
	}

	submit() {
		let objSchedule = this.editShiftForm.value;
		//console.log(objSchedule);
		let objShift = objSchedule.shifts;
		
		let currdate = new Date();
		let shiftObj = [];
		for (let j in objShift) {
			shiftObj[j] = objShift[j];
			shiftObj[j].providers = [];
		}

		//console.log(objSelectedDoctors);
		//create collection of this user
		var self = this;
		var afsObj = this.afs;
		var router = this.router;
		var hospId = self.selectedInstitution['id'];
		var hospRef = this.afs.doc('institutions/' + hospId);
		var sdlRef = this.afs.doc('schedules/' + self.activeId);
		self.spinnerService.show();
		//update schedule
		self.afs.collection('schedules').doc(self.activeId).update({
			name: objSchedule.name,
			tags: objSchedule.tags,
			modified: firebase.firestore.FieldValue.serverTimestamp()
		}).then(function (res) {
			let objUser = firebase.auth().currentUser;
			self.afs.collection("admin_logs").add({
				'user_id': objUser.uid,
				'type': 'edit_schedule',
				'data': { schedule_id: self.activeId },
				'created': firebase.firestore.FieldValue.serverTimestamp()
			});
			self.spinnerService.hide();
		});
	}

	ngOnInit() {
		this.activeId = '';
		this.route.params.subscribe(p => {
			if (p.id) {
				this.activeId = p.id;
				this.getScheduleDetails(this.activeId);
			}
		});
		this.editShiftForm = this.fb.group({
			name: ['', Validators.required],
			tags: []
			// start_date: ['', Validators.required],
			// end_date: ['', Validators.required],
			// shifts: this.fb.array([
			// 	this.initShift(),
			// 	this.initShift(),
			// 	this.initShift(),
			// 	this.initShift(),
			// 	this.initShift(),
			// 	this.initShift(),
			// 	this.initShift()
			// ])
		});

		this.weekList = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		this.getUserProfile();
		this.getDepartmentList();
		//console.log(this.objSchedule);

	}
	
}



// WEBPACK FOOTER //
// ./src/app/modules/schedules/edit-schedule/edit-schedule.component.ts